import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getRegisterResult } from 'apis/registerResult';

const useGetRegisterResult = (projectId, conds = {}) => {
  const { data: registerResultData, ...rest } = useQuery(
    ['getRegisterResult', projectId],
    () => getRegisterResult(projectId),
    {
      ...conds,
    }
  );

  const registerResult = useMemo(() => registerResultData?.data ?? [], [registerResultData]);

  return {
    data: registerResult,
    ...rest,
  };
};

export default useGetRegisterResult;
